// export const predictData = {
//     MonthlyAvgPreciptation: [0.021, 0.052, 0.118571, 0.163866, 0.196165],
//     MonthlyAvgSnowfall: [0.0, 0.034677, 0.131068, 0.184848, 0.308654],
//     MonthlyTotalSnowfall: [0.5, 1.7, 3.0, 4.9, 7.4],
//     MonthlyAvgDaylight: [618.24, 717.935, 731.27, 827.8333, 930.0548],
//     MonthlyAvgTemp: [9.78, 13.39, 17.06, 23.28, 25.78],
//     MonthlyAvgTempDiff: [7.890161, 10.600234, 11.815559, 13.060484, 15.230363],
//     MonthlyAvgRelativeHumidity: [
//         48.875, 59.578902, 66.933333, 74.016129, 77.643805,
//     ],
//     MonthlyAvgWindSpeed: [5.055667, 7.0825, 8.466129, 9.668548, 10.903379],
// };

export const predictQuestion = {
    MonthlyAvgPreciptation:
        "I would like to live in a place with less precipitation.",
    MonthlyAvgSnowfall:
        "I would like to live in a place with very little snow.",
    MonthlyTotalSnowfall:
        "I would like to live in a place with very little snow.",
    MonthlyAvgDaylight: "I would like to live in a place with less sunlight.",
    MonthlyAvgTemp: "I would like to live in a cold place.",
    MonthlyAvgTempDiff:
        "I would like to live in a place where the temperature doesn’t change a lot in a day.",
    MonthlyAvgRelativeHumidity:
        "I would like to live in a place with less humidity.",
    MonthlyAvgWindSpeed: "I would like to live in a place with less wind.",
    MonthlyMaxPrecip:
        "I would like to live in a place with nearly no huge rain.",
    MonthlyMaxSnowfall:
        "I would like to live in a place with nearly no huge snow.",
    MonthlyAvgPeakWindSpeed:
        "I would like to live in a place with nearly no huge wind.",
    MonthlyAvgSnowDepth:
        "I would like to live in a place with shallower snow or even no snow.",
    MonthlyMaxTempDiff:
        "I would like to live in a place with nearly no huge temperature difference.",
    MonthlyMinDailyTempDiff:
        "I would like to live in a place where the temperature barely changes per day.",
};

export const attributes = [
    "MonthlyMaxPrecip",
    "MonthlyTotalSnowfall",
    "MonthlyMaxSnowfall",
    "MonthlyAvgTemp",
    "MonthlyAvgDaylight",
    "MonthlyAvgTempDiff",
    "MonthlyAvgPreciptation",
    "MonthlyAvgRelativeHumidity",
    "MonthlyAvgWindSpeed",
    "MonthlyAvgPeakWindSpeed",
    "MonthlyAvgSnowDepth",
    "MonthlyAvgSnowfall",
    "MonthlyMaxTempDiff",
    "MonthlyMinDailyTempDiff",
];
export const answers = [
    "Strongly agree",
    "Agree",
    "Neither agree nor disagree",
    "Disagree",
    "Strongly disagree",
];
